import { SlotType } from 'services/slotOrchestration/types';

export const isCollectionSlotType = (slotType: SlotType) =>
  slotType === SlotType.GROCERY_COLLECTION || slotType === SlotType.ENTERTAINING_COLLECTION;
